import { IconLogo } from '@components/icons/IconLogo';
import useEditingStore from '@hooks/useEditingStore';
import useLangString from '@hooks/useLangString';
import { $tourData } from '@stores/dataStores';
import { $editingFlag, $editingUIColor } from '@stores/editingStores';
import type { TemplateId } from '@types';
import { getTemplateConfig } from '@utils/templateConfig';
import { WFirstSceneButton } from './WFirstSceneButton';
import WLogo from './WLogo';
import { WSandTableButton } from './WSandTableButton';
import useNickname from './useNickname';

interface Props {
  templateId: TemplateId;
}

function WUserInfo({ templateId }: Props) {
  const { name } = useNickname();
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => {
      const ui = state.config?.ui;
      const defaultUI = getTemplateConfig(templateId)('uiColor') ?? {};
      if (!ui) return defaultUI;
      return { ...defaultUI, ...ui };
    },
    $editing: $editingUIColor.store,
  });

  const lang = useLangString(
    {
      author: ['创作者：', 'Author: '],
      pv: ['～人来过', '～ views'],
    },
    []
  );

  const showName = !!(flag?.showAuthorName ?? 1);
  const showPv = !!(flag?.showTourPV ?? 1);

  return (
    <div className="absolute top-20 left-20">
      {(showName || showPv) && (
        <div
          className="mb-15 flex items-center"
          style={{ color: `rgba(${ui.fontColor})` }}
        >
          {showName && <div className="mr-20">{`${lang.author}${name}`}</div>}
          {showPv && <div>{lang.pv}</div>}
        </div>
      )}
      <WLogo
        systemIcon={<IconLogo width={60} color={`rgba(${ui.fontColor})`} />}
      />
      <WSandTableButton />
      <WFirstSceneButton />
    </div>
  );
}

export default WUserInfo;
